// extracted by mini-css-extract-plugin
module.exports = {"ExpandableText":"ExpandableText_3uAOq"};